<div class="new-test-container">
  <!-- Phone side of a cross-device handoff: redeeming the token + signing in. -->
  <div class="test-resuming" *ngIf="resuming">
    <div class="test-resuming-spinner" aria-label="loading"></div>
  </div>

  <!-- Desktop/tablet: face-scan capture gated to phone (QR handoff). -->
  <app-phone-handoff
    *ngIf="showPhoneHandoff && !resuming"
    [scanId]="scanId || null"
    step="selfie"
    (back)="closePhoneHandoff()"
  ></app-phone-handoff>

  <ng-container *ngIf="!showPhoneHandoff && !resuming">
  <div class="test-header">
    <!-- F2 / B2: the one exit for this screen, at the start of the header, so
         the global bottom nav no longer has to carry a Back tab here. -->
    <button type="button" class="nt-back" (click)="goBack()" [attr.aria-label]="backLabel">
      <svg class="rtl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>
  </div>

  <div class="test-content">
    <h1 class="test-title">{{ title }}</h1>
    <p class="test-subtitle">{{ subtitle }}</p>

    <div class="steps-container">
      <div class="test-step" *ngFor="let step of testSteps" [class.active]="step.isActive"
        [class.disabled]="!step.isActive" (click)="onStepClick(step)">
        <div class="step-number">
          @if(step.isPassed && !step.isActive) {
          <mat-icon>check</mat-icon>
          } @else {
          {{ step.number }}
          }
        </div>

        <div class="step-info">
          <h3 class="step-title">{{ step.title }}</h3>
          <p class="step-description">{{ step.description }}</p>
        </div>

        @if(step.isActive && !step.isPassed && canSkipTests()) {
        <button mat-stroked-button class="skip-button" [disabled]="skipping" (click)="onSkipStep(step, $event)">
          {{ skipDevText }}
        </button>
        }

        <div class="step-arrow" *ngIf="step.isActive">
          <mat-icon class="rtl-icon">keyboard_arrow_right</mat-icon>
        </div>
      </div>
    </div>

    <p class="test-disclaimer">{{ medicalDisclaimer }}</p>
  </div>
  </ng-container>
</div>
